import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ubi-layout-data-grid',
  templateUrl: './ubiLayoutDataGrid.component.html',
  styleUrls: ['./ubiLayoutDataGrid.component.scss']
})
export class UbiLayoutDataGridComponent implements OnInit {

  @Input() options: any;

  @Input() filters: any[];

  @Input() filterNL = '';

  @Output()
  new = new EventEmitter();

  @Output()
  excel = new EventEmitter();

  @Output()
  filter = new EventEmitter();

  @Output()
  advancedSearch = new EventEmitter();

  @Output()
  eraseFilter = new EventEmitter();

  constructor() { }

  ngOnInit() {
    const defaultOptions = {
      new: true,
      excel: true
    };

    this.options = Object.assign(defaultOptions, this.options);

  }

  public newClick(event) {
    this.new.emit();
  }

  public excelClick(event) {
    this.excel.emit();
  }

  public filterClick(event) {
    this.filter.emit(event);
  }

  public advancedSearchClick(event) {
    this.advancedSearch.emit(event);
  }

  public eraseFilterClick(event) {
    this.eraseFilter.emit(event);
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLayoutDataGrid/ubiLayoutDataGrid.component.ts